import dynamic from 'next/dynamic';

// Old version of Swiper does not support propper ssr
// imported on the client in order to make it compatible
// TODO: migrate Swiper to newer version / replace with another lib

const Carousel = dynamic(() => import('./Carousel'), { ssr: false });

export default Carousel;
